const AnswersState = {
    userAnswers:'',
    standardAnswers:[],
    hasRecorded : false,
    isShowingAnswer: false
}


export default AnswersState